import { render, staticRenderFns } from "./CustomerPaid.vue?vue&type=template&id=a08fefa4&scoped=true"
import script from "./CustomerPaid.vue?vue&type=script&lang=js"
export * from "./CustomerPaid.vue?vue&type=script&lang=js"
import style0 from "./CustomerPaid.vue?vue&type=style&index=0&id=a08fefa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08fefa4",
  null
  
)

export default component.exports